<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import VisitFinalizationDialogActionBar from './VisitFinalizationDialogActionBar.vue';
import VisitFinalizationHouseDescription from './VisitFinalizationHouseDescription.vue';
import VisitFinalizationHouseImage from './VisitFinalizationHouseImage.vue';
import {
  visitFinalizationDialogTitle,
  visitFinalizationPropertyTitle,
} from '../utils/visitFinalizationDialogPresenter';

const props = defineProps({
  show: { type: Boolean, default: false },
  candidate: { type: Object, default: null },
  imageSrc: { type: String, default: '' },
  address: { type: String, default: '' },
  dateText: { type: String, default: '—' },
});

const emit = defineEmits(['close', 'finish']);

const dialogTitle = computed(() =>
  visitFinalizationDialogTitle(props.candidate)
);
const propertyTitle = computed(() =>
  visitFinalizationPropertyTitle(props.candidate)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    :title="dialogTitle"
    max-width-class="max-w-[430px]"
    @close="emit('close')"
  >
    <section class="grid gap-4">
      <VisitFinalizationHouseImage
        :image-src="imageSrc"
        :title="propertyTitle"
      />
      <VisitFinalizationHouseDescription
        :date-text="dateText"
        :address="address"
      />
    </section>

    <template #footer>
      <VisitFinalizationDialogActionBar @finish="emit('finish', $event)" />
    </template>
  </LaisModal>
</template>
